import {
  Component,
  inject,
  OnInit,
  Input,
  ViewChild,
  SimpleChanges,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ApiService } from '@core/providers/http/api.service';
import { BolsaService } from '../../api/services/bolsa.service';
import { ToastModule } from 'primeng/toast';
import { MessageService, MenuItem, ConfirmationService } from 'primeng/api';
import { Bolsa } from '../../api/models/bolsa.model';
import { CardBolsaComponent } from '@shared/components/card-bolsa/card-bolsa.component';
import { Menu } from 'primeng/menu';
import { FilterItem } from '../../api/models/filterItem.model';
import { Pagination } from '../../../../../shared/model/pagination.model';
import {
  TableColumn,
  TableComponent,
} from '../../../../../shared/components/table/table.component';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { ComprovativoSubsidioModalComponent } from '../../auxilio-formacao/comprovativo-subsidio-modal/comprovativo-subsidio-modal.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { EnumService } from '../../api/services';
import { forkJoin } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { DocAnexoDrawerComponent } from '../detalhe-bolseiro/doc-anexo-drawer/doc-anexo-drawer/doc-anexo-drawer.component';
import { DrawerModule } from 'primeng/drawer';
import { TextareaModule } from 'primeng/textarea';
import { LancarNotasComponent } from '../lancar-notas/lancar-notas.component';

@Component({
  selector: 'app-listar-bolsa-bolseiros',
  standalone: true,
  imports: [
    CommonModule,
    CardBolsaComponent,
    RouterModule,
    Button,
    ToastModule,
    ComprovativoSubsidioModalComponent,
    ConfirmDialogModule,
    PaginatorControlComponent,
    TableComponent,
    SearchBarComponent,
    DataVoidComponent,
    DialogModule,
    InputText,
    SelectModule,
    ReactiveFormsModule,
    DocAnexoDrawerComponent,
    DrawerModule,
    TextareaModule,
    LancarNotasComponent,
  ],
  providers: [
    ApiService,
    MessageService,
    BolsaService,
    DialogService,
    ConfirmationService,
    EnumService,
  ],
  templateUrl: './listar-bolsa-bolseiros.component.html',
  styleUrls: ['./listar-bolsa-bolseiros.component.scss'],
})
export class ListarBolsaBolseirosComponent implements OnInit {
  @Input() bolseiroID!: string;
  bolseiro = input<any>();
  bolsaService = inject(BolsaService);
  messageService = inject(MessageService);
  confirmationService = inject(ConfirmationService);
  enumService = inject(EnumService);
  constructor(private fb: FormBuilder) {}

  bolsas: Bolsa[] = [];
  form!: FormGroup;
  paginatedBolsas: Bolsa[] = [];
  isLoading: boolean = false;
  sortFields: any[] = [{ label: 'Nome', value: 'nome' }];
  router = inject(Router);
  dialogService = inject(DialogService);

  tipoBolsaOptions: any[] = [
    { id: 1, designacao: 'Interna' },
    { id: 2, designacao: 'Externa' },
  ];

  niveisAcademicos: any[] = [];
  estados: any[] = [];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'TipoBolsaID',
      placeholder: 'Tipo de bolsa',
      options: this.tipoBolsaOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'NivelAcademico',
      placeholder: 'Nivel académico',
      options: this.niveisAcademicos,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoBolsa',
      placeholder: 'Estado',
      options: this.estados,
      optionLabel: 'label',
      optionValue: 'id',
    },
  ];

  pagination: Pagination<any> = new Pagination<any>();
  showAlterarEstado = false;
  alterarEstadoForm!: FormGroup;
  bolsaParaAlterarEstado: any | null = null;
  showDocs = false;
  selectedBolsa: any | null = null;
  drawerNotasVisible = false;
  selectedBolsaParaNotas: any | null = null;

  actions: MenuItem[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      command: ($e: any) => this.callRouteEditBolsa($e.item?.data),
    },
    {
      label: 'Renovações',
      icon: 'pi pi-info-circle',
      command: ($e: any) => this.callRouteDetailsBolseiro($e.item.data),
    },
    {
      label: 'Ficha de cadastro',
      icon: 'pi pi-download',
      command: ($e: any) => this.gerarComprovativo(Number($e.item?.data?.id)),
    },
    {
      label: 'Documentos',
      icon: 'pi pi-folder-open',
      command: ($e: any) => this.openDocsDrawer($e.item?.data),
    },
    {
      label: 'Alterar Estado',
      icon: 'pi pi-refresh',
      command: ($e: any) => this.openAlterarEstadoModal($e.item?.data),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: ($e: any) => this.deleteBolsa($e.item.data),
    },
    {
      label: 'Ver Notas',
      icon: 'pi pi-clipboard',
      command: ($e: any) => this.abrirDrawerNotas($e.item?.data),
    },
  ];

  openDocsDrawer(bolsa: any) {
    this.selectedBolsa = bolsa;
    this.showDocs = true;
  }
  @ViewChild('menu') menu!: Menu;

  ngOnInit() {
    this.loadAllBolsa();
    this.loadDropdowns();

    this.form = this.fb.group({
      TipoBolsaID: [null],
      NivelAcademico: [null],
      EstadoBolsa: [null],
    });

    this.alterarEstadoForm = this.fb.group({
      estadoBolsa: [null, Validators.required],
      observacao: ['', Validators.required],
    });
  }

  columns: TableColumn[] = [
    {
      field: 'nomeRequerente',
      header: 'Requerente',
      type: 'text',
      tooltip: 'Requerente',
    },
    {
      field: 'tipoBolsaDescricao',
      header: 'Tipo',
      type: 'text',
      tooltip: 'Tipo de Bolsa',
    },
    { field: 'pais', header: 'País de Estudo', type: 'text', tooltip: 'País' },
    {
      header: 'Fase de formação',
      type: 'text',
      valueGetter: (r: any) => r?.matricula?.[0]?.fase ?? '—',
    },
    {
      header: 'Curso',
      type: 'text',
      valueGetter: (r: any) => r?.matricula?.[0]?.curso ?? '—',
    },
    {
      header: 'Ano curricular',
      type: 'text',
      valueGetter: (r: any) => r?.matricula?.[0]?.anoCurricular ?? '—',
    },
    {
      header: 'Instituição de Ensino',
      type: 'text',
      valueGetter: (r: any) => {
        const m = r?.matricula?.[0];
        const inst = m?.instituicaoEnsino?.trim();
        const uo = m?.unidadeOrganica?.trim();
        return [inst, uo].filter(Boolean).join(' - ') || '—';
      },
      tooltip: 'Instituição + Unidade Orgânica',
    },
    {
      field: 'estadoBolsaDescricao',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoBolsa',
      tagSeverityFunction: (rowData: any) =>
        this.getSeverity(rowData.estadoBolsaDescricao),
      tooltip: 'Estado da Bolsa',
    },
  ];

  loadDropdowns() {
    forkJoin({
      estadoBolsa: this.enumService.getAllEstadoBolsaEnum(),
      nivelAcademico: this.enumService.getAllNivelAcademicoMIREMPETEnum(),
    }).subscribe((response) => {
      if (response.estadoBolsa?.data) {
        this.estados = Object.entries(response.estadoBolsa.data).map(
          ([key, value]) => ({ id: Number(key), label: value }),
        );
        this.filters[2].options = this.estados;
      }
      if (response.nivelAcademico?.data) {
        this.niveisAcademicos = Object.entries(
          response.nivelAcademico.data,
        ).map(([key, value]) => ({ id: Number(key), label: value }));
        this.filters[1].options = this.niveisAcademicos;
      }
    });
  }

  toggleMenu(event: Event) {
    this.menu.toggle(event);
  }

  callRouteEditBolsa(data: any) {
    this.router.navigate(
      [
        'gestao-bolseiros/auxilio-formacao/cadastrar-auxilio-formacao/' +
          data.bolseiro.numeroBI,
      ],
      { queryParams: { auxilioFormacaoId: data.id } },
    );
  }

  callRouteDetailsBolseiro(bolseiro: Bolsa) {
    if (bolseiro && bolseiro.id) {
      this.router.navigate([
        `gestao-bolseiros/auxilio-formacao/detalhes-auxilio-formacao/${bolseiro.id}`,
      ]);
    }
  }

  public gerarComprovativo(id: number) {
    const body = {
      tipoDocumento: 5,
      estadoDocumento: 0,
      utilizadorID: 'string',
      dados: { bolsaID: id },
    };
    this.bolsaService.gerarFichaCadastro(body).subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Ficha de cadastro.pdf';
      document.body.appendChild(a);
      a.click();
    });
  }

  openComprovativoSubsidioModal() {
    const ref = this.dialogService.open(ComprovativoSubsidioModalComponent, {
      showHeader: false,
      width: '35%',
    });
    ref.onClose.subscribe(() => {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters']) {
    }
  }

  deleteBolsa(bolsa: Bolsa) {
    this.confirmationService.confirm({
      message: 'Tem a certeza que deseja eliminar esta bolsa?',
      accept: () => {
        this.bolsaService.delete(bolsa.id).subscribe({
          next: (res: any) => {
            const ok = res?.retorno?.codigo === 200 || res?.data === true;
            if (ok) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Bolsa eliminada com sucesso',
              });
              this.loadAllBolsa();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: `Erro ${res?.retorno?.codigo ?? ''}`.trim(),
                detail: 'Erro ao eliminar a bolsa',
              });
            }
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: error?.message || 'Erro ao eliminar a bolsa',
            });
          },
        });
      },
    });
  }

  loadAllBolsa(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
      BolseiroID: this.bolseiroID,
    };
    this.bolsaService.list(params).subscribe(
      (response) => {
        this.pagination = new Pagination<any>().deserialize(response);
        this.pagination.totalRecords =
          response.totalRecords || response.total || response.data.length;
      },
      (error) => {
        console.error('Erro ao carregar bolsa:', error);
      },
    );
  }

  getSeverity(status: string) {
    switch (status) {
      case 'Activo':
        return 'success';
      case 'Inactivo':
        return 'warn';
      case 'Suspenso':
        return 'danger';
      case 'Finalizado':
        return 'success';
      case 'Pendente':
        return 'info';
      default:
        return 'warn';
    }
  }

  transformNivelAcademico(nivel: string): string {
    return nivel;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllBolsa();
  }

  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.actions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  abrirDrawerNotas(bolsa: any) {
    this.selectedBolsaParaNotas = bolsa;
    this.drawerNotasVisible = true;
  }

  callRouteCreateBolseiro() {
    this.router.navigate([
      'gestao-bolseiros/auxilio-formacao/cadastrar-auxilio-formacao/' +
        this.bolseiro().numeroBI,
    ]);
  }

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    this.loadAllBolsa(filters);
    this.showFilter = false;
  }

  openAlterarEstadoModal(bolsa: any) {
    this.bolsaParaAlterarEstado = bolsa;
    this.alterarEstadoForm.reset();
    this.showAlterarEstado = true;
  }

  submitAlterarEstado() {
    if (this.alterarEstadoForm.invalid) {
      this.alterarEstadoForm.markAllAsTouched();
      return;
    }
    const { estadoBolsa, observacao } = this.alterarEstadoForm.value;
    const id = Number(this.bolsaParaAlterarEstado?.id);

    this.bolsaService.atualizarEstado(id, estadoBolsa, observacao).subscribe({
      next: (res: any) => {
        const ok =
          res?.retorno?.codigo === 200 ||
          res?.data === true ||
          res?.success === true;
        if (ok) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Estado da bolsa alterado com sucesso',
          });
          this.showAlterarEstado = false;
          this.loadAllBolsa();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: `Erro ${res?.retorno?.codigo ?? ''}`.trim(),
            detail: res?.retorno?.mensagem || 'Erro ao alterar o estado',
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: error?.message || 'Erro ao alterar o estado da bolsa',
        });
      },
    });
  }
}